import { on } from '@ngrx/store';
import { createReducer } from '@ngrx/store';
import { ActionReducer } from '@ngrx/store/src/models';
import { SessionTokenActions } from 'app/modules/darwin/store/session-token/session-token.actions';
import { SessionTokenState } from 'app/modules/darwin/store/session-token/session-token.state';

export class SessionTokenReducer {

  private static readonly initialState: SessionTokenState = { tokenLoaded: false };
  private static readonly failedState: SessionTokenState = { tokenLoaded: true };

  private static readonly onSessionTokenLoaded = on(
    SessionTokenActions.sessionTokenLoaded,
    (state: SessionTokenState, { token }) =>
      ({
        token,
        tokenLoaded: true,
      })
  );

  private static readonly onSessionTokenLoadFailed = on(
    SessionTokenActions.sessionTokenLoadFailed,
    (_state: SessionTokenState) => SessionTokenReducer.failedState
  );

  static reducer(): ActionReducer<SessionTokenState> {

    return <ActionReducer<SessionTokenState>>createReducer(
      SessionTokenReducer.initialState,
      SessionTokenReducer.onSessionTokenLoaded,
      SessionTokenReducer.onSessionTokenLoadFailed,
    );
  }

}
